import { jsx as _jsx } from "react/jsx-runtime";
import { Table } from '@sovryn/ui';
import { useEffect, useState } from 'react';
import { COLUMNS_CONFIG } from './TransactionHistoryFrame.constants';
import { generateRowTitle, getHistory } from './TransactionHistoryFrame.utils';
import { useAccount as useEVMAccount } from 'wagmi';
import { useAccount } from '@gobob/sats-wagmi';
export const TransactionHistoryFrame = () => {
    const { address: btcAddress } = useAccount();
    const { address: evmAddress } = useEVMAccount();
    const [isLoading, setIsLoading] = useState(false);
    const [transactions, setTransactions] = useState([]);
    useEffect(() => {
        setIsLoading(true);
        getHistory({
            targetAddress: evmAddress,
            originAddress: btcAddress,
        }).then(txs => {
            setTransactions(txs);
            setIsLoading(false);
        });
    }, [evmAddress, btcAddress]);
    return (_jsx("div", { className: "mx-auto w-full lg:max-w-screen-lg lg:px-9", children: _jsx("div", { className: "bg-gray-90 lg:p-6 p-3 rounded-[0.625rem] max-w-screen-lg mx-auto border border-[#313355] shadow-basic", children: _jsx(Table, { columns: COLUMNS_CONFIG, rows: transactions, rowTitle: generateRowTitle, className: "text-gray-40 lg:px-6 lg:py-4 text-[0.813rem]", rowClassName: "text-gray-10 font-inter font-medium text-[0.813rem] bg-gray-90", noData: _jsx("div", { className: "text-xs font-normal text-gray-30 bg-transparent min-h-6 lg:min-h-auto flex items-center justify-center", children: "You don\u2019t have any transactions yet" }), loadingData: _jsx("div", { className: "text-xs font-normal text-gray-30 bg-gray-60 lg:bg-transparent min-h-6 lg:min-h-auto flex items-center justify-center", children: "Loading transactions" }), dataAttribute: "transactions", row: true, isLoading: isLoading }) }) }));
};
